module.exports = __webpack_public_path__ + "google_play.png?7395aba12fb23429294d759d15e1ca91";


//////////////////
// WEBPACK FOOTER
// ./src/assets/static/google_play.png
// module id = 59
// module chunks = 0